export const AUTH_TOKEN = 'project/auth/TOKEN';
export const REFRESH_TOKEN = 'project/auth/REFRESH_TOKEN';
export const LANG = 'project/config/LANG';
export const IMPORT_TASK_ID = 'project/translations/TASK_ID';

export function writeToLocalState(key, state) {
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch (e) {
    throw e;
  }
}

export const getFromLocalStorage = (key) => {
  let state;

  try {
    state = JSON.parse(localStorage.getItem(key)) || null;
  } catch (e) {
    throw e;
  }

  return state;
};

export function clearLocalState(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    throw e;
  }
}
